
import { Vue, Prop, Component } from "vue-property-decorator";
import { formatDateWithTime } from "@/utils";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import notifications from "../../lib/notifications";
import permissions from "@/security/permissions";

const orderModule = getModule(OrderModule);

@Component({
  computed: {
    permissions() {
      return permissions
    }
  }
})
export default class OrderDocuments extends Vue {
  groupSize = 8;
  thumbnails = [];

  @Prop({ default: false })
  loading: boolean;
  downloading: boolean = false;
  loadFeedbackFormExists: boolean = false;

  mounted() {
    console.log("OrderDocuments mounted");
    this.fetchLoadFeedbackFormExists();
  }

  get images() {
    let imageArray = orderModule.currentOrderThumbnails;
    return imageArray;
  }

  get currentOrder() {
    return orderModule.currentOrder;
  }

  async fetchLoadFeedbackFormExists() {
    const payload = {
      orderNumber: orderModule.currentOrder.headerNumber
    };
    console.log("fetchLoadFeedbackFormExists", payload);

    try {
      const exists = await orderModule.getOrderLoadFeedbackFormExists(payload);
      console.log("fetchLoadFeedbackFormExists result", exists);
      this.loadFeedbackFormExists = exists;
    } catch (error) {
      console.error("Error fetching load feedback form existence", error);
      this.loadFeedbackFormExists = false;
    }
  }


  showImage(imageIndex: number) {
    orderModule.currentOrderImageIndex = imageIndex;
    orderModule.showImagesModal();
  }

  showMessageDialog() {
    var payload = {
      selectedItems: [orderModule.currentOrder, []]
    };
    this.$store.dispatch("order/messageCustomerShortcutAction", payload, { root: true });
  }

  showUploadDialog() {
    orderModule.showImageUploadModal();
  }

  downloadUrl(url: string, name: string) {
    var link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = name;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
        link.parentNode.removeChild(link);
    }, 0);
  }

  downloadImage(imageIndex: number) {
    if(this.downloading) return;

    this.downloading = true;
    notifications.display("Download Started", "Downloading single page.", "info");

    var image = this.images[imageIndex];
    if(image.imageUrl) {
      let fileName = `bc-${this.images[imageIndex].id}-${this.images[imageIndex].page}.jpg`
      this.downloadUrl(this.images[imageIndex].imageUrl, fileName);
    } else {
      let payload = {
        source: image.source,
        id: image.id,
        page: image.page
      }

      orderModule.getImage(payload)
        .then(result =>  {
          this.downloadUrl(result.url, result.fileName);
          notifications.success("Download Complete", "Page downloaded.");
        })
        .catch((error) => {
          notifications.error("Download Failed", "Unable to download page.", error);
        })
        .finally(() => {
          this.downloading = false;
        });
    }
  }

  sendImage(imageIndex: number) {
    var image = this.images[imageIndex];
    var payload = {
      selectedItems: [orderModule.currentOrder, [`${image.source}-${image.id}-${image.page}`]]
    };
    this.$store.dispatch("order/messageCustomerShortcutAction", payload, { root: true });
  }

  downloadImageBundle() {
    if(this.downloading) return;

    this.downloading = true;
    notifications.display("Download Started", "Downloading all order images.", "info");

    const payload = {
        orderNumber: orderModule.currentOrder.headerNumber,
        documentIds: []
      };

    orderModule.getOrderImageBundle(payload)
      .then(result => {
        var file = new Blob([result], {type: "application/pdf"});
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = `order-${orderModule.currentOrder.headerNumber}.pdf`;
        document.body.appendChild(link);
        link.click();

        notifications.success("Download Complete", "Order images downloaded.");

        setTimeout(() => {
          link.parentNode.removeChild(link);
        }, 0);
      })
      .catch(error => {
        notifications.error("Download Failed", "Unable to download orders.", error);
      })
      .finally(() => {
        this.downloading = false;
      });
  }

  downloadLoadFeedbackForm() {
    if(this.downloading) return;

    this.downloading = true;
    notifications.display("Download Started", "Downloading load feedback form.  This may take a few moments.", "info");

    const payload = {
      orderNumber: orderModule.currentOrder.headerNumber
    };

    orderModule.getOrderLoadFeedbackForm(payload)
      .then(result => {
        if (!result) {
          notifications.display("Load Feedback Form", "Load feedback form is not found.", "info");
          return;
        }

        var file = new Blob([result], {type: "application/pdf"});
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = `lff-${payload.orderNumber}.pdf`;
        document.body.appendChild(link);
        link.click();

        notifications.success("Download Complete", "Load feedback form downloaded.");

        setTimeout(() => {
          link.parentNode.removeChild(link);
        }, 0);
      })
      .catch(error => {
        notifications.error("Download Failed", "Unable to download load feedback form.", error);
      })
      .finally(() => {
        this.downloading = false;
      });
  }
}
